/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Alarms_Import_PreviewInputs */



/**
* | output |
* | --- |
* | "Preview of alarms to import ({count})" |
*
* @param {Alarms_Import_PreviewInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const alarms_import_preview = /** @type {((inputs: Alarms_Import_PreviewInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Import_PreviewInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Preview of alarms to import (${i?.count})`)
	return /** @type {LocalizedString} */ (`Aperçu des alarmes à importer (${i?.count})`)
});